import React from 'react';

const PROGRESS_RADIUS = 16;
const PROGRESS_CIRCUMFERENCE = 2 * Math.PI * PROGRESS_RADIUS;

const ProgressCircle = ({ item }) => {
  const fallbackProgress = Number(item?.total_rows)
    ? (Number(item?.processed_rows || 0) / Number(item.total_rows)) * 100
    : 0;
  const progressPercent = Number(item?.progress_percent ?? fallbackProgress) || 0;
  const status = item?.status?.toLowerCase?.();
  const isFinished = progressPercent >= 100 || ['completed', 'completed_with_errors'].includes(status);
  const percent = isFinished ? 100 : Math.min(Math.max(progressPercent, 0), 100);
  const dashOffset = PROGRESS_CIRCUMFERENCE - (percent / 100) * PROGRESS_CIRCUMFERENCE;
  const strokeColor = status === 'failed' ? '#DC2626' : isFinished ? '#22C55E' : '#2563EB';

  return (
    <div className="d--flex align-items--center justify-content--end gap--sm w--full">
      <div className="d--flex align-items--center justify-content--center" style={{ position: 'relative', width: 44, height: 44 }} data-tooltip={isFinished ? 'Completed' : `${percent}%`} tooltip-position="bottom">
        <svg width="44" height="44" viewBox="0 0 44 44">
          <circle cx="22" cy="22" r={PROGRESS_RADIUS} fill="none" stroke="#E5E7EB" strokeWidth="4" />
          <circle cx="22" cy="22" r={PROGRESS_RADIUS} fill="none" stroke={strokeColor} strokeWidth="4" strokeLinecap="round" strokeDasharray={PROGRESS_CIRCUMFERENCE} strokeDashoffset={dashOffset} transform="rotate(-90 22 22)" />
        </svg>
        <span className="font--sm font--600" style={{ position: 'absolute', color: strokeColor, lineHeight: 1 }}>
          {isFinished ? '\u2713' : ''}
        </span>
      </div>
    </div>
  );
};

export default ProgressCircle;
